import { NgModule } from '@angular/core';
import { DateValueAccessor } from './date-value-accessor';

@NgModule({
  declarations: [DateValueAccessor],
  exports: [DateValueAccessor]
})
export class DateValueAccessorModule { }
